// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"850549ec","513":"a81bb04a","703":"7608887f","787":"e4f6a8ed"}[chunkId] + ".chunk.js";
};